import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Truck } from "lucide-react";
import { authClient, useCustomerAuth } from "@/context/CustomerAuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useCustomerAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/account";
    (async () => {
      try {
        const { data } = await authClient.post("/auth/customer/session", { session_id: sessionId });
        setUser(data);
        toast.success(`Signed in as ${data.name || data.email}`);
        navigate(target, { replace: true, state: { user: data } });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Sign-in failed. Please try again.");
        navigate("/account", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#FAF8F5] grid place-items-center">
      <div className="flex items-center gap-3 text-[#0C2E2B]">
        <div className="w-10 h-10 rounded-md bg-[#0C2E2B] grid place-items-center animate-pulse"><Truck className="w-5 h-5 text-[#FFDF00]" /></div>
        <span className="font-display font-black">Signing you in…</span>
      </div>
    </div>
  );
}
